<template>
    <div class="d-inline-flex favorite" @click.stop.prevent="setFavorite" v-if="device && device.show_favorite">
        <div
            v-if="device.is_favorite"
            v-html="require('!html-loader!@/assets/icons/heart_filled_icon.svg')"
            class="size-22"
        />
        <div
            v-else
            v-html="require('!html-loader!@/assets/icons/heart_icon.svg')"
            class="size-22 disabled-image"
        />
    </div>
</template>

<script>
export default {
    name: "DeviceFavorite",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        }
    },
    methods: {
        setFavorite() {
            this.$parent.$emit('switch-favorite', this.device);
        },
    },
}
</script>